const MAX_SEARCH_QUERY_LOG_LENGTH = 256

function isControlCharacter(char: string): boolean {
  const code = char.charCodeAt(0)
  return code <= 0x1f || code === 0x7f
}

export default function sanitizeSearchQueryForLog(searchQuery: string): string {
  return searchQuery
    .trim()
    .split('')
    .map((char) => (isControlCharacter(char) ? ' ' : char))
    .join('')
    .replace(/\s+/g, ' ')
    .slice(0, MAX_SEARCH_QUERY_LOG_LENGTH)
}
